import { Tooltip } from "antd";
import classNames from "classnames";
import styles from "./style.module.scss";
import React from "react";
import { CloseIcon } from "views/pages/DataPage/CardsView/DataPageFilters/SearchContainer/Icons";
interface IconButtonProps {
  onClick: (e: any) => void;
  title?: string;
  text?: string;
  className?: string;
  variant?: "primary" | "success" | "danger";
  icon?: React.ReactNode;
  onClose?: () => void;
  active?: boolean;
}

export default function IconButton({
  onClick,
  className,
  variant,
  icon,
  text,
  onClose,
  active,
  title,
}: IconButtonProps) {
  return (
    <Tooltip title={title}>
      <div
        onClick={(e) => {
          e.stopPropagation();
          if (onClose) {
            onClose();
          } else {
            onClick(e);
          }
        }}
        className={classNames(
          variant === "success" && styles.success,
          variant === "danger" && styles.danger,
          variant === "primary" && styles.primary,
          active && styles.active,
          styles.noDetailsClick,
          styles.actionButton,
          className,
        )}
      >
        <div className={styles.content}>
          {icon && icon}
          {!onClose && text}
          {onClose && (
            <CloseIcon
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            />
          )}
        </div>
      </div>
    </Tooltip>
  );
}
